import { W3AccordionGroup } from "./components/W3AccordionGroup";
import { W3Blog } from "./components/W3Blog";
import { W3CardReveal } from "./components/W3CardReveal";
import { W3Counter } from "./components/W3Counter";
import { W3ErrorPage } from "./components/W3ErrorPage";
import { W3FadeInText } from "./components/W3FadeInText";
import { W3FooterNavigation } from "./components/W3FooterNavigation";
import { W3HeaderNavigation } from "./components/W3HeaderNavigation";
import { W3JobBlock } from "./components/W3JobBlock";
import { W3MultiCardSlider } from "./components/W3MultiCardSlider";
import { W3OnPageNavigation } from "./components/W3OnPageNavigation";
import { W3ReferenceSlider } from "./components/W3ReferenceSlider";
import { W3ScrollCards } from "./components/W3ScrollCards";
import { W3ScrollHistory } from "./components/W3ScrollHistory";
import { W3SearchButton } from "./components/W3SearchButton";
import { W3CardStack } from "./components/W3CardStack";
import { W3Video } from "./components/W3Video";
import { W3FormManipulation } from "./components/W3FormManipulation";

(function ($) {
  new W3AccordionGroup();
  new W3Blog();
  new W3Counter();
  new W3CardReveal();
  new W3ErrorPage();
  new W3FadeInText();
  new W3FooterNavigation();
  new W3HeaderNavigation();
  new W3JobBlock();
  new W3MultiCardSlider();
  new W3OnPageNavigation();
  new W3ReferenceSlider();
  new W3ScrollCards();
  new W3ScrollHistory();
  new W3SearchButton();
  new W3Video();
  new W3FormManipulation();

  // use multiple card stacks on the same page
  document.addEventListener("DOMContentLoaded", () => {
    document.querySelectorAll(".w3-card-stack").forEach((element) => {
      new W3CardStack(element as HTMLElement);
    });
  });
})(jQuery);
